// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 5V21H15V23H2V5H4Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 1H16L21 6V19H6V1ZM15 3V7H19L15 3Z"}}]};

const FileCopyFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-copy-filled',
    ref,
    icon: element,
  },
));

FileCopyFilledIcon.displayName = 'FileCopyFilledIcon';

export default FileCopyFilledIcon;
